import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { Goals } from '../../../models/dashboard/goals/goal';

const syncGoalServices = (userId: string, ): Promise<any> => {
    return adminHttpClient.put(`/api/Admin/AdminGoals/syn-goals-balance?userId=${userId}`,null)
}
export default syncGoalServices;